import { Component, OnInit } from '@angular/core';
import { GipContractFormatForm, GipContractFormatModel } from '../gipAdmContract.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/workflow/admin/admin.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationWindow } from 'src/app/template/deleteTemplate/confirmationWindow.component';

@Component({
  selector: 'app-gip-contract-format-form',
  templateUrl: './gipContractFormatForm.component.html',
  styleUrls: ['./gipContractFormatForm.component.css']
})
export class GipContractFormatFormComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private adminService: AdminService,
    private shareData: SharingDataService,
    private errorHandlingService: ErrorHandlingService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    public dialog: MatDialog,
  ) { }

  public modelInput = GipContractFormatForm;
  private contractId: string;
  public resourceDefinition: any;
  public isEdit: boolean;
  public isNew: boolean = false;
  private id: string;
  private urlBase: string = "admin/MS_FORMAT_CONTRACT";
  private contractUrl: string = "admin/MS_CONTRACT";

  formular = [
    { formControlName: "ID", hidden: true, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "CONTRACT_ID", hidden: false, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "CONTRACT_NUMBER", hidden: false, required: true, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "CONTRACT_NAME", hidden: false, readonly: true, editReadonly: true, newReadonly: true },
    { formControlName: "FORMAT_ID", hidden: false, picklist: "V_MS_FORMAT_VL", required: true, readonly: false, editReadonly: false, newReadonly: false },
    { formControlName: "ORDINAL", hidden: false, inputNumber: true, readonly: false, editReadonly: false, newReadonly: false },
    { formControlName: "btn_back", button: true, function: "btnBackAction", type:"button",newRow: true},
    { formControlName: "btn_save", button: true, function: "btnSaveAction", type:"submit"},
    { formControlName: "btn_delete", button: true, function: "btnDeleteAction", type:"button"},
    
  ];

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.getUrlParams();

    if (!this.isNew)
      this.getData();
      else this.getContractData();
  }

  action(action) {
    this[action]();
  }
  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.contractId != undefined) {
          this.contractId = params.contractId;
        }
        if (params.id != undefined) {
          this.id = params.id;
          this.setReadonly();
        } else this.changeToNew();

        if (params.isEdit != undefined) {
          this.isEdit = params.isEdit;
          this.setReadonly();
        }
      });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }

  changeToEdit() {
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay() {
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.isNew = true;
    this.modelInput.reset();
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
    this.formular.forEach(element => {
      if(element.formControlName == "btn_delete"){ element.hidden = true; }
    });
  }

  getData() {
    let urls = [
      `${this.urlBase}?$filter=ID eq ${this.id}`,
    ];
    var data = this.adminService.getData(urls, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var statisticElement in this.modelInput.value) {
            if (dataElement == statisticElement) {
              this.modelInput.controls[statisticElement].setValue(data[0][0][dataElement])
            }
          }
        }
      }
      let secondUrl = [`${this.contractUrl}?$filter=ID eq ${this.modelInput.value.CONTRACT_ID}`];
      data = this.adminService.getData(secondUrl, (data) => {
        if (data[0][0] != undefined) {
          for (var dataElement in data[0][0]) {
            if (dataElement === 'ID'){
              continue;
            }
            for (var statisticElement in this.modelInput.value) {
              if (dataElement == statisticElement) {
                this.modelInput.controls[statisticElement].setValue(data[0][0][dataElement])
              }
            }
          }
        }
      });
    });
  }

  getContractData(){
    if (this.contractId != undefined){
      var data = this.adminService.getData([this.contractUrl + `?$filter=ID eq ${this.contractId}`], (data) => {
        if (data[0][0] != undefined) {
          for (var dataElement in data[0][0]) {
            if (dataElement === 'ID'){
              this.modelInput.controls.CONTRACT_ID.setValue(data[0][0][dataElement]);
              continue;
            }
            for (var statisticElement in this.modelInput.value) {
              if (dataElement == statisticElement) {
                this.modelInput.controls[statisticElement].setValue(data[0][0][dataElement])
              }
            }
          }
        }
      });
    }
  }

  btnSaveAction() {
    if (this.isNew)
      this.postData();
      else this.updateData();
  }

  postData(){
    if(this.modelInput.status == "VALID"){
      let model = new GipContractFormatModel();
      model.fromFormGroupModel(this.modelInput);
      let response: any;
      this.adminService.postData(this.urlBase, model, (data) => {
        response = data;
        console.log(response);
        this.btnBackAction();
      },
      (response) => {
        if (response.status == 409)
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFailAlreadyExists', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined)
          else
          this.errorHandlingService.showError(this.translateResourceDefinition.transform('PortalTechnicalFail', this.resourceDefinition, 'KEY_NAME', "LONG_TEXT", "Common"), undefined);
      });
    }
  }

  updateData(){
    if(this.modelInput.status == "VALID"){
      let model = new GipContractFormatModel();
      model.fromFormGroupModel(this.modelInput);

      this.adminService.updateData(this.urlBase, model, model.getUpdateMap(), (data) => {
        let response = data;
        console.log(response);
        this.btnBackAction();
      },
      );
    }
  }
  

  btnDeleteAction() {
    const dialogRef = this.dialog.open(ConfirmationWindow, {
      data: {
        Title : "ConfirmDeleteTitle",
        Text : "ConfirmDeleteText",
        Placeholders: [this.modelInput.value.USERNAME],
        Actions: [{
          Text: "ConfirmYes",
          Function: "REMOVE",
        },
        {
          Text: "ConfirmNo",
        }]
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "REMOVE") {
        let model = new GipContractFormatModel();
        model.fromFormGroupModel(this.modelInput);
        this.adminService.deleteData(this.urlBase, model.getUpdateMap(), (data) => {
        this.btnBackAction();
        });
      }
    });
  }

  btnBackAction() {
    this.router.navigate(["/gipContractFormatList"], { queryParams: { id: this.contractId }})
  }
}


